import { pageNumberAdjuster } from '../normalize/pageNumberAdjuster';

export const createSsapInputId = (page, indexInArray, fields, name, areAllFieldsMixed = undefined, valueToPass = null) => {
    const getFields = arr => {
        if(Array.isArray(arr)) {
            return arr.length === 0
                ? ''
                : areAllFieldsMixed
                    ? `_${arr.join('_')}`
                    : `_${arr[arr.length - 1]}`;
        } else {
            return '';
        }
    };

    const getHouseholdMemberIndex = index => {
        switch(true) {
            case typeof index === 'number':
                return index;
            case Array.isArray(index):
                return index.reduce((outputStr, el) => {
                    const suffix = getHouseholdMemberIndex(el);
                    if(suffix !== null) {
                        return `${outputStr}_${getHouseholdMemberIndex(el)}`;
                    } else {
                        return outputStr;
                    }
                }, '');
            default:
                return null;
        }
    };

    const append = value => {
        switch(true) {
            case typeof value === 'string':
                return `_${value.toLowerCase()}`;
            case typeof value === 'number':
                return `_${value}`;
            default:
                return '';
        }
    };

    const prepend = value => value !== null ? `_hhm${value}` : '';

    return [
        pageNumberAdjuster(page),
        prepend(getHouseholdMemberIndex(indexInArray)),
        getFields(fields),
        `_${name}`,
        append(valueToPass)
    ].join('');
};